import { OptanonNPAFlag } from 'services/OptanonNPAFlag';

window.CBS.Registry.OptanonNPAFlagPromise = (() => {
    window.cbsoptanon = window.cbsoptanon || { cmd: [] };
    return OptanonNPAFlag.getInstance(window.cbsoptanon).getNPAFlag();
})();
